<template>
  <div>
    <v-row class="text-center mb-4">
      <v-col>
        <div class="d-flex flex-column align-center px-10">
          <font-awesome-icon :icon="['fas', 'sliders-v-square']"
                             class="ChooseFormula__icon text-deep-purple mb-4"
          />
          <p class="mb-6 text--medium text--bold">
            {{ $t('projects.dialogs.ProjectsNewDataroomDialogChooseFormula.specificNeed') }}
          </p>
          <div class="mb-6">
            {{ $t('projects.dialogs.ProjectsNewDataroomDialogChooseFormula.activateDataRoom') }}
          </div>
          <AppButton color="primary"
                     @click="$emit('configureClicked')"
          >
            {{ $t('projects.dialogs.ProjectsNewDataroomDialogChooseFormula.configure') }}
          </AppButton>
        </div>
      </v-col>
      <v-divider vertical/>
      <v-col>
        <div class="d-flex flex-column align-center px-10">
          <font-awesome-icon :icon="['fas', 'envelope']"
                             class="ChooseFormula__icon text-deep-purple mb-4"
          />
          <p class="mb-6 text--medium text--bold">
            {{ $t('projects.dialogs.ProjectsNewDataroomDialogChooseFormula.recurringNeed') }}
          </p>
          <div class="mb-6">
            {{ $t('projects.dialogs.ProjectsNewDataroomDialogChooseFormula.contactUsForSubscription') }}
          </div>
          <AppButton
            data-locator="contact-us-button"
            color="primary"
            @click="$emit('requestActivation')"
          >
            {{ $t('projects.dialogs.ProjectsNewDataroomDialogChooseFormula.contactUs') }}
          </AppButton>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import AppButton from '@/common/buttons/AppButton.vue'

export default {
  name: 'ProjectsNewDataroomDialogChooseFormula',
  components: { AppButton },
}
</script>

<style scoped lang="scss">
.ChooseFormula {
  &__icon {
    font-size: 25px;
  }
}
</style>
